import {StockId, TaskDescription, TaskPriority} from "@/app/tasks/definitions/taskCommon.render.form";
import {TaskStockTakingRestriction} from "@/enum/task_stock_taking_restriction";
import i18n from "@/service/lang/i18n";
import {TaskPriority as TaskPriorityEnum} from "@/enum/task_priority";
import Vue from "vue";

const restrictTypeItems = () => {
    return Object.values(TaskStockTakingRestriction).map(restrictionType => ({
        text: i18n.t('tasks.stockTaking.restrictions.' + restrictionType),
        value: restrictionType
    }));
};

function StockTakingCreateForm() {
    return {
        priority: TaskPriorityEnum.NORMAL,
        description: null,
        restrict_type: TaskStockTakingRestriction.NONE,
        restrict_reference_id: null,
        stock_locations: null,
        stock_id: null,
        attachments: []
    };
}

function StockTakingCreateRender() {
    return {
        priority: new TaskPriority,
        stock_id: new StockId,
        restrict_type: {
            icon: '$restrictType',
            select: restrictTypeItems()
        },
        stock_locations: {
            icon: '$taskStockTakingLocations',
            autocomplete: {
                items: [],
                multiple: true
            },
            show: false,
            loading: false
        },
        restrict_reference_id: {
            icon: '$manufacturer',
            autocomplete: {
                items: [],
                render: item => item.text || Vue.options.filters.productLabel(item)
            },
            show: false,
            loading: false
        },
        description: new TaskDescription
    };
}

export {StockTakingCreateForm, StockTakingCreateRender};
